<template>
    <div class="ev0-box" id="ev0-box">
        <div class="evaluate-box" id="evaluate-box" v-if="list.length>0" infinite-scroll-immediate="false" v-infinite-scroll="load" >
            <div v-for="(item,index) in list" class="evaluate-item" :key="index">
                <div class="top-box">
                    <div>
                        <img style="object-fit: cover;" :src="item.avatar?$severUrl(item.avatar):$user" alt="">
                        <div style="margin-left: 2rem;">{{ item.userName?item.userName[0]+' * *':'' }}</div>
                    </div>
                    <div>
                        <div class="time">{{ item.evaluateTime }}</div>
                        <el-rate v-model="item.evaluateScore" disabled></el-rate>
                    </div>
                </div>
                <div class="content">{{ item.evaluateContent }}</div>
            </div>
        </div>
        <no-data v-else></no-data>
    </div>
</template>

<script>
import { PageQueryEvaluate } from '@/api/evaluate';
import NoData from '../../common/NoData.vue';
export default {
  components: { NoData },
  props:['businessType','businessId'],
        data(){
            return {
                list:[],
                pages:{
                    current:1,
                    size:10,
                    total:0,
                    flag:false
                }
            }
        },
        methods:{
            courseEvaluateList(){
                var params={
                "businessId": this.$route.query.id||this.businessId,
                "current": this.pages.current,
                "businessType":this.businessType,
                "evaluateType": "general",
                "size": this.pages.size
                }
                this.pages.flag=true;
                PageQueryEvaluate(params).then(res=>{
                    if(res.code==200){
                        if(this.pages.current==1){
                            this.list=res.data.records;
                        }else{
                            this.list=[...this.list,...res.data.records];
                        }
                        this.pages.total=res.data.total;
                        this.pages.totalPages=Math.ceil(res.data.total/this.pages.size);
                        this.$nextTick(()=>{
                            this.pages.flag=false
                        })
                        this.$emit('get_total',res.data.total);
                    }
                })
            },
            load(){
                if(this.pages.totalPages<=this.pages.current)return;
                this.pages.current++;
                this.courseEvaluateList();
            }
        },
        mounted(){
            this.courseEvaluateList();
        }
    }
</script>

<style lang="less" scoped>
.ev0-box{
    margin-top: 6rem;
}
.evaluate-box{
    color: #334681;
    &> :nth-child(n){
        margin-top: 6rem;
    }
    &> :nth-child(1){
        margin-top: 0;
    }
    .top-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        &> :nth-child(n){
            display: flex;
            align-items: center;
        }
        img{
            width: 6.6rem;
            height: 6.6rem;
            border-radius: 50%;
        }
        .time{
            font-size: 1.3rem;
            color: #8590B3;
            margin-right: 1rem;
        }
    }
}
.content{
    font-size: 1.3rem;
    margin-top: 1rem;
    white-space: var(--lineWrap);
    word-break: break-all;
}
</style>